import './penne/style';
import FormStructure from './penne/form_structure';

export default FormStructure;